import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App.jsx"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import store from "./store/store"

import { LoadingBarContainer } from "react-top-loading-bar"
const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
	<Provider store={store}>
		<React.StrictMode>
			<LoadingBarContainer>
				<App />
			</LoadingBarContainer>
		</React.StrictMode>
	</Provider>
)

reportWebVitals()


